export default __webpack_public_path__ + "static/media/rauchmelder_stockwerk1.e49b83c2.png";